import { DatePipe } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'

import { ActiveSorting } from '../../abstracts/table-base.abstract'
import { Address } from '../../models/address.model'
import { HighLightTextPipe } from '../../pipes/high-light-text.pipe'
import { MergeColumnsPipe } from '../../pipes/merge-columns.pipe'
import {
  ChangeEventParams,
  TableColumn,
  TableComponent,
  TableDataBase,
} from '../table/table.component'

export type TableData = TableDataBase & Address

@Component({
  selector: 'app-master-addresses',
  imports: [
    TableComponent,
    DatePipe,
    HighLightTextPipe,
    TranslatePipe,
    MergeColumnsPipe,
  ],
  templateUrl: './master-addresses.component.html',
})
export class MasterAddressesComponent {
  @Input({ required: true }) public tableData!: TableData[]
  @Input({ required: true }) public sword!: string
  @Input({ required: true }) public total!: number
  @Input({ required: true }) public pageSize!: number
  @Input({ required: true }) public pageIndex!: number
  @Input({ required: true }) public isLoading!: boolean
  @Input({ required: true }) public defaultSorting!: ActiveSorting
  @Input() public extraColumns: TableColumn[] = []
  @Output() public changeHandler = new EventEmitter<ChangeEventParams>()
}
